<template>
  <div style="font-size: 1.5em">
    <b-icon :icon="icon" :variant="variant" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.value ? "check" : "x";
    },
    variant() {
      return this.value ? "success" : "danger";
    },
  },
};
</script>
